import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { appReducer } from '@verantos-dev/core-utils';

import { annotationToolApi } from './annotationToolApi';

// Intentionally empty so types can be extended and roll up to this module
// eslint-disable-next-line @typescript-eslint/no-empty-interface,@typescript-eslint/no-empty-object-type
export interface LazyLoadedSlices {}

// tie store to reducer registry
export const rootReducer = combineSlices({
  app: appReducer,
  [annotationToolApi.reducerPath]: annotationToolApi.reducer,
}).withLazyLoadedSlices<LazyLoadedSlices>();

export const store = configureStore({
  reducer: rootReducer,
  // preloadedState: initialState,
  // Additional middleware can be passed to this array
  // Middleware<{}, RootState<Definitions, string, ReducerPath>, ThunkDispatch<any, any, AnyAction>>;
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // .concat([localhostApiV2.middleware])
      .concat([annotationToolApi.middleware]),
  devTools: !import.meta.env.PROD,
  // Optional Redux store enhancers
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
